const mergeReducer = (ranges, current, index) => {
    if (index === 0) {
        return [current];
    }
    const previous = ranges.pop();
    if (current.from === previous.from) {
        return [...ranges, previous];
    }
    if (Math.abs(current.from - previous.to) <= 1) {
        ranges.push({ from: previous.from, to: current.to });
    } else if (Math.abs(current.to - previous.from) <= 1) {
        ranges.push({ from: current.from, to: previous.to });
    } else {
        ranges.push(previous);
        ranges.push(current);
    }
    return ranges;
};

const ignoreDuplicates = (programs, program, index) => {
    if (index === 0) {
        return [program];
    }
    if (!programs.find(({ id }) => program.id && program.id === id)) {
        return [...programs, program];
    }
    return programs;
};

export const mergeRanges = (current = [], next) =>
    [...current, next].sort((first, second) => first.from - second.from).reduce(mergeReducer, []);

export const mergePrograms = (current = [], next = []) =>
    [...current, ...next]
        .sort((first, second) => first.start - second.start)
        .reduce(ignoreDuplicates, []);
